import React, { useState } from 'react';
import { Modal, Button } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

const IMAGE_TYPES = /^image\//i;

export default function CommentAttachments({ attachments, className }) {
  const list = Array.isArray(attachments) ? attachments.filter((a) => a && a.url) : [];
  const imageItems = list.filter((a) => IMAGE_TYPES.test(a.type || ''));
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewIndex, setPreviewIndex] = useState(0);

  if (list.length === 0) return null;

  const openImagePreview = (idx) => {
    const item = list[idx];
    if (!item || !IMAGE_TYPES.test(item.type || '')) return;
    const imageIdx = imageItems.findIndex((img) => img.url === item.url);
    setPreviewIndex(imageIdx >= 0 ? imageIdx : 0);
    setPreviewOpen(true);
  };

  return (
    <div className={`comment-attachments ${className || ''}`}>
      {list.map((att, idx) => {
        const isImage = IMAGE_TYPES.test(att.type || '');
        const name = att.name || `Attachment ${idx + 1}`;
        if (isImage) {
          return (
            <button
              key={idx}
              type="button"
              className="comment-attachment comment-attachment-image"
              onClick={() => openImagePreview(idx)}
              title={name}
            >
              <img src={att.url} alt={name} />
            </button>
          );
        }
        return (
          <a
            key={idx}
            href={att.url}
            target="_blank"
            rel="noopener noreferrer"
            download={name}
            className="comment-attachment comment-attachment-file"
          >
            {name}
          </a>
        );
      })}
      <Modal
        title={imageItems[previewIndex]?.name || `Image ${previewIndex + 1}`}
        open={previewOpen}
        onCancel={() => setPreviewOpen(false)}
        footer={null}
        width="auto"
        centered
        className="comment-attachment-preview-modal"
        styles={{
          body: {
            padding: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8,
            minHeight: 200,
          },
        }}
      >
        {imageItems.length > 0 && (
          <>
            {previewIndex > 0 && (
              <Button
                type="text"
                icon={<LeftOutlined />}
                onClick={() => setPreviewIndex((i) => i - 1)}
                className="comment-attachment-preview-nav"
              />
            )}
            <img
              src={imageItems[previewIndex]?.url}
              alt={imageItems[previewIndex]?.name || ''}
              style={{ maxHeight: '80vh', maxWidth: '70vw', objectFit: 'contain' }}
            />
            {previewIndex < imageItems.length - 1 && (
              <Button
                type="text"
                icon={<RightOutlined />}
                onClick={() => setPreviewIndex((i) => i + 1)}
                className="comment-attachment-preview-nav"
              />
            )}
          </>
        )}
      </Modal>
    </div>
  );
}
